import { render, staticRenderFns } from "./analyze.vue?vue&type=template&id=2af32d68&scoped=true"
import script from "./analyze.vue?vue&type=script&lang=js"
export * from "./analyze.vue?vue&type=script&lang=js"
import style0 from "./analyze.vue?vue&type=style&index=0&id=2af32d68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af32d68",
  null
  
)

export default component.exports